<div class="Card" [ngStyle]="{ height: alturaCard }">
  <div class="AreaArrastavel">
    <input maxFileSize="1000000" type="file" #fileInput id="uploadFile" name="uploadFile" multiple="false" accept=".pdf,image/*"
      (change)="Upload($event)" />

    <!-- Mostra imagem -->
    <div *ngIf="urlDocumentoSelecionado && !pdfSelecionado" class="preview-container">
      <img [src]="urlDocumentoSelecionado" alt="Prévia do Documento." style="height: 100%" />
      <div class="info-arquivo">
        <strong style="color: var(--primary-color)">{{ nomeArquivo }}</strong>
        <p>Tipo: {{ tipoArquivo }}</p>
        <p>{{ tamanhoArquivo }}</p>
      </div>
    </div>

    <!-- Mostra PDF -->
    <div *ngIf="pdfSelecionado" class="pdf-container">
      <i class="pi pi-file-pdf icone-arquivo"></i>
      <div class="info-arquivo">
        <strong style="color: var(--primary-color)">{{ nomeArquivo }}</strong>
        <p>Tipo: {{ tipoArquivo }}</p>
        <p>{{ tamanhoArquivo }}</p>
      </div>
    </div>

    <!-- Estado inicial -->
    <div *ngIf="!urlDocumentoSelecionado && !pdfSelecionado" class="empty-state">
      <i class="fa-regular fa-image icone-arquivo"></i>
      <div class="info-arquivo">
        <strong style="color: var(--primary-color)">{{ nomeArquivo }}</strong>
        <p>{{ textoTipoETamanho }}</p>
        <p>{{ tamanhoArquivo }}</p>
      </div>
    </div>

  </div>
</div>